





















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Popover, Tabs, TabPane } from 'element-ui';
import { AcgnPop } from '@acgn/herm/src/ui';
import { namespace } from 'vuex-class';
import event from '@acgn/herm/src/util/event';
const TaskGroupAction = namespace('desk/taskGroup').Action;
const TaskGroupGetter = namespace('desk/taskGroup').Getter;
const CommGetter = namespace('desk/comm').Getter;

@Component({
  components: {
    AcgnPop,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Popover.name]: Popover
  }
})
export default class AcgnDepot extends Vue {
  @Prop() public visible: any; // 是否显示弹框
  @Prop() public projectName: any; // 项目名称
  @Prop() public comicId: any; // 项目id
  @TaskGroupAction private recycleBin: any; // 任务组
  @TaskGroupAction private recycleBinTask: any; // 任务
  @TaskGroupAction private setStatusTaskGroup: any; // 删除任务组
  @TaskGroupAction private setStatusTask: any; // 删除任务
  @TaskGroupAction private getTaskCycleStatus: any; // 验证任务组恢复状态
  @CommGetter private attributeData: any; // 公共类型

  private groupList: any = [];
  private taskList: any = [];
  private activeName: any = 'first';
  get show() {
    return this.visible;
  }
  set show(v) {
    this.$emit('update:visible', v);
  }
  @Watch('visible')
  private init() {
    if (this.visible) {
      this.getGroupList();
      this.getTaskList();
    }
  }

  // 恢复任务组
  private async getRecoverGroup(item: any) {
    if (item.rec_name === '恢复') {
      item.rec_name = '确认恢复至原处';
      return false;
    }
    const params = {
      recycle_status: 0,
      group_id: item.id
    };
    await this.setStatusTaskGroup(params);
    this.getGroupList();
    event.emit('$refreshTaskList');
    this.$message.success('任务组已恢复');
  }

  // 任务恢复，恢复其任务组
  private async getRecoverAll(taskId: any) {
    const params = {
      recycle_status: 0,
      task_id: taskId
    };
    await this.setStatusTask(params);
    this.getTaskList();
    this.getGroupList();
    event.emit('$refreshTaskList');
    this.$message.success('任务已恢复');
  }

  // 恢复任务
  private async getRecoverTask(item: any) {
    if (item.rec_name === '恢复') {
      item.rec_name = `确认恢复至${item.group_name}`;
      return false;
    }
    const { result } = await this.getTaskCycleStatus({ group_id: item.group_id });
    const h = this.$createElement;
    if (result === 1) {
      this.$msgbox({
        title: '该任务所属的任务组已被删除，恢复任务同时将恢复该任务组',
        message: h('div', {}, [
          h('p', {}, `任务组名：${item.group_name} `),
          h('p', {}, `任务名：${item.task_name} `)
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        this.getRecoverAll(item.id);
      }).catch((ex) => { });
      return false;
    } else {
      const params = {
        recycle_status: 0,
        task_id: item.id
      };
      await this.setStatusTask(params);
      this.getTaskList();
      event.emit('$refreshTaskList');
      this.$message.success('任务已恢复');
    }
  }

  // 审批状态样式
  private getClassSta(status: any) {
    switch (status) {
      case 0:
        return 'color--success';
      case 1:
        return 'color--gray';
      case 2:
        return 'color--danger';
    }
  }

  // 审批状态列表
  private get statusName() {
    return this.attributeData.other_type[3];
  }

  // 任务列表
  private getChildTask(item: any) {
    const arr = JSON.parse(item.tasks);
    let str = '';
    arr.map((i: any) => {
      str += i.task_name + '、';
    });
    str = str.substring(0, str.length - 1);
    return str;
  }

  // 环节列表
  private getChildLink(item: any) {
    const arr = JSON.parse(item.links);
    let str = '';
    arr.map((i: any) => {
      str += i.name + '、';
    });
    str = str.substring(0, str.length - 1);
    return str;
  }

  // 审批状态名称
  private getNameSta(status: any) {
    return this.statusName[status].name;
  }

  // 获取任务组
  private async getGroupList() {
    const params = {
      project_id: this.comicId
    };
    const { result } =  await this.recycleBin(params);
    result.list.map((i: any) => {
      i.rec_name = '恢复';
    });
    this.groupList = result.list;
  }

  // 获取任务
  private async getTaskList() {
    const params = {
      project_id: this.comicId
    };
    const { result } =  await this.recycleBinTask(params);
    result.list.map((i: any) => {
      i.rec_name = '恢复';
    });
    this.taskList = result.list;
  }

  private submit() {
    this.show = false;
  }
}
